import { isNothing, just, nothing, type Maybe } from "./maybe";
import type { WorldPoint } from "./mapGeometry";

let grainTile: Maybe<HTMLCanvasElement> = nothing;

/** A repeatable paper tooth. Generated once; anchored to map space, never time. */
export function drawMapPaperGrain(
  ctx: CanvasRenderingContext2D,
  toScreen: (point: WorldPoint) => WorldPoint,
  width: number,
  height: number,
): void {
  if (isNothing(grainTile)) {
    const tile = document.createElement("canvas");
    tile.width = 256;
    tile.height = 256;
    const paint = tile.getContext("2d");
    if (paint === null) return;
    let seed = 74291;
    const random = (): number => {
      seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
      return seed / 4294967296;
    };
    for (let i = 0; i < 9000; i++) {
      const light = i % 3 !== 0;
      paint.fillStyle = light
        ? "rgba(255,249,232,0.12)"
        : "rgba(62,48,30,0.07)";
      const x = random() * 256;
      const y = random() * 256;
      paint.fillRect(x, y, 0.4 + random() * 1.1, 0.3 + random() * 0.7);
    }
    grainTile = just(tile);
  }
  const pattern = ctx.createPattern(grainTile.value, "repeat");
  if (pattern === null) return;
  const origin = toScreen({ x: 0, y: 0 });
  const unit = toScreen({ x: 1, y: 1 });
  pattern.setTransform(
    new DOMMatrix([
      unit.x - origin.x,
      0,
      0,
      unit.y - origin.y,
      origin.x,
      origin.y,
    ]),
  );
  ctx.save();
  ctx.fillStyle = pattern;
  ctx.fillRect(0, 0, width, height);
  ctx.restore();
}
